// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddTravelPlan_container__6wOJj {
  background-color: rgba(0, 0, 0, 0.2);
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 200000;
}
.AddTravelPlan_container__6wOJj::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.AddTravelPlan_container__6wOJj::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.8);
}
.AddTravelPlan_container__6wOJj::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: hsl(0, 0%, 90%);
  box-shadow: inset 0 0 1px 1px #616161;
}
.AddTravelPlan_container__6wOJj::-webkit-scrollbar-thumb:hover {
  background-color: hsl(0, 0%, 85%);
  background-color: hsl(0, 0%, 80%);
}
@media screen and (max-width: 600px) {
  .AddTravelPlan_container__6wOJj {
    padding: 0;
    bottom: 47px;
  }
}
@media screen and (min-width: 600px) {
  .AddTravelPlan_container__6wOJj {
    padding: 47px;
    left: 80px;
    overflow: scroll;
  }
}
.AddTravelPlan_container__6wOJj .AddTravelPlan_add-flight-plan__qW3bU {
  background-color: white;
  padding: 30px;
  box-shadow: var(--shadow);
  border-radius: 5px;
  margin: auto;
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
}
@media screen and (max-width: 600px) {
  .AddTravelPlan_container__6wOJj .AddTravelPlan_add-flight-plan__qW3bU {
    width: 100%;
    padding: 20px;
    overflow-y: scroll;
    max-height: 100%;
    border-radius: 0;
  }
}
.AddTravelPlan_container__6wOJj .AddTravelPlan_add-flight-plan__qW3bU .AddTravelPlan_inputs__6s4l- {
  position: relative;
}
.AddTravelPlan_container__6wOJj .AddTravelPlan_add-flight-plan__qW3bU .AddTravelPlan_inputs__6s4l- .AddTravelPlan_heading__GokYp {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}
.AddTravelPlan_container__6wOJj .AddTravelPlan_add-flight-plan__qW3bU .AddTravelPlan_inputs__6s4l- .AddTravelPlan_heading__GokYp h3 {
  margin: 0;
}
.AddTravelPlan_container__6wOJj .AddTravelPlan_add-flight-plan__qW3bU .AddTravelPlan_inputs__6s4l- .AddTravelPlan_errors__8P1-2 {
  color: red;
  text-align: center;
}
.AddTravelPlan_container__6wOJj .AddTravelPlan_add-flight-plan__qW3bU .AddTravelPlan_inputs__6s4l- .AddTravelPlan_date-input-row__jXDyr,
.AddTravelPlan_container__6wOJj .AddTravelPlan_add-flight-plan__qW3bU .AddTravelPlan_inputs__6s4l- .AddTravelPlan_place-input-row__imSpQ {
  margin-bottom: 5px;
}
.AddTravelPlan_container__6wOJj .AddTravelPlan_add-flight-plan__qW3bU .AddTravelPlan_inputs__6s4l- .AddTravelPlan_date-input-row__jXDyr > *,
.AddTravelPlan_container__6wOJj .AddTravelPlan_add-flight-plan__qW3bU .AddTravelPlan_inputs__6s4l- .AddTravelPlan_place-input-row__imSpQ > * {
  margin: 5px;
}
@media screen and (max-width: 350px) {
  .AddTravelPlan_container__6wOJj .AddTravelPlan_add-flight-plan__qW3bU .AddTravelPlan_inputs__6s4l- .AddTravelPlan_date-input-row__jXDyr {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
}
.AddTravelPlan_container__6wOJj .AddTravelPlan_add-flight-plan__qW3bU .AddTravelPlan_inputs__6s4l- .AddTravelPlan_place-input-row__imSpQ {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.AddTravelPlan_container__6wOJj .AddTravelPlan_add-flight-plan__qW3bU .AddTravelPlan_inputs__6s4l- .AddTravelPlan_place-input-row__imSpQ .AddTravelPlan_place-input-container__iW-\\+F {
  max-width: calc(50% - 30px);
}
.AddTravelPlan_container__6wOJj .AddTravelPlan_add-flight-plan__qW3bU .AddTravelPlan_inputs__6s4l- .AddTravelPlan_place-input-row__imSpQ .AddTravelPlan_place-input-container__iW-\\+F .AddTravelPlan_place-input__U9\\+6w {
  background-color: white;
  width: 220px;
}
.AddTravelPlan_container__6wOJj .AddTravelPlan_add-flight-plan__qW3bU .AddTravelPlan_inputs__6s4l- .AddTravelPlan_text-details__8lSqP {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 7px;
}
.AddTravelPlan_container__6wOJj .AddTravelPlan_add-flight-plan__qW3bU .AddTravelPlan_inputs__6s4l- .AddTravelPlan_text-details__8lSqP input,
.AddTravelPlan_container__6wOJj .AddTravelPlan_add-flight-plan__qW3bU .AddTravelPlan_inputs__6s4l- .AddTravelPlan_text-details__8lSqP textarea {
  margin: 3px 0;
  border: 1px solid #d2d2d2;
  border-radius: 4px;
  padding: 5px 10px;
  width: 100%;
}
.AddTravelPlan_container__6wOJj .AddTravelPlan_add-flight-plan__qW3bU .AddTravelPlan_inputs__6s4l- .AddTravelPlan_text-details__8lSqP input,
.AddTravelPlan_container__6wOJj .AddTravelPlan_add-flight-plan__qW3bU .AddTravelPlan_inputs__6s4l- .AddTravelPlan_text-details__8lSqP textarea,
.AddTravelPlan_container__6wOJj .AddTravelPlan_add-flight-plan__qW3bU .AddTravelPlan_inputs__6s4l- .AddTravelPlan_place-input-row__imSpQ .AddTravelPlan_place-input-container__iW-\\+F .AddTravelPlan_place-input__U9\\+6w {
  outline: none;
  box-shadow: 0 0 0 0 var(--accent-color-02-opacity);
}
.AddTravelPlan_container__6wOJj .AddTravelPlan_add-flight-plan__qW3bU .AddTravelPlan_inputs__6s4l- .AddTravelPlan_text-details__8lSqP input:focus,
.AddTravelPlan_container__6wOJj .AddTravelPlan_add-flight-plan__qW3bU .AddTravelPlan_inputs__6s4l- .AddTravelPlan_text-details__8lSqP textarea:focus,
.AddTravelPlan_container__6wOJj .AddTravelPlan_add-flight-plan__qW3bU .AddTravelPlan_inputs__6s4l- .AddTravelPlan_place-input-row__imSpQ .AddTravelPlan_place-input-container__iW-\\+F .AddTravelPlan_place-input__U9\\+6w:focus {
  border-color: var(--accent-color-light);
  box-shadow: 0 0 0 3px var(--accent-color-02-opacity);
}
.AddTravelPlan_container__6wOJj .AddTravelPlan_add-flight-plan__qW3bU .AddTravelPlan_inputs__6s4l- .AddTravelPlan_privacy-level__pkop\\+ {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 10px 0;
}
.AddTravelPlan_container__6wOJj .AddTravelPlan_add-flight-plan__qW3bU .AddTravelPlan_inputs__6s4l- .AddTravelPlan_privacy-level__pkop\\+ > * {
  margin-right: 10px;
}
.AddTravelPlan_container__6wOJj .AddTravelPlan_add-flight-plan__qW3bU .AddTravelPlan_button-container__dABF7 {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Home/AddTravelPlan/AddTravelPlan.module.scss"],"names":[],"mappings":"AAAA;EACG,oCAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;AACH;AACG;EACG,WAAA;EACA,YAAA;AACN;AAEG;EACG,4CAAA;AAAN;AAGG;EACG,kBAAA;EACA,iCAAA;EACA,qCAAA;AADN;AAIG;EACG,iCAAA;EAIA,iCAAA;AANN;AASG;EAhCH;IAiCM,UAAA;IACA,YAAA;EAHJ;AACF;AAKG;EArCH;IAsCM,aAAA;IACA,UAAA;IACA,gBAAA;EAFJ;AACF;AAIG;EACG,uBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EAAA,kBAAA;EACA,wBAAA;EAAA,mBAAA;AAFN;AAIM;EATH;IAUM,WAAA;IACA,aAAA;IACA,kBAAA;IACA,gBAAA;IACA,gBAAA;EADP;AACF;AAGM;EACG,kBAAA;AADT;AAGS;EACG,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;AADZ;AAGY;EACG,SAAA;AADf;AAKS;EACG,UAAA;EACA,kBAAA;AAHZ;AAMS;;EAEG,kBAAA;AAJZ;AAMY;;EACG,WAAA;AAHf;AAQY;EADH;IAEM,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,uBAAA;IACA,eAAA;EALb;AACF;AAQS;EACG,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AANZ;AAQY;EACG,2BAAA;AANf;AAQe;EACG,uBAAA;EACA,YAAA;AANlB;AAWS;EACG,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AATZ;AAWY;;EAEG,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;AATf;AAaS;;;EAGG,aAAA;EACA,kDAAA;AAXZ;AAaY;;;EACG,uCAAA;EACA,oDAAA;AATf;AAaS;EACG,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;AAXZ;AAaY;EACG,kBAAA;AAXf;AAgBM;EACG,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;AAdT","sourcesContent":[".container {\n   background-color: #0003;\n   position: fixed;\n   left: 0;\n   top: 0;\n   right: 0;\n   bottom: 0;\n   z-index: 200000;\n\n   &::-webkit-scrollbar {\n      width: 10px;\n      height: 10px;\n   }\n\n   &::-webkit-scrollbar-track {\n      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.8)\n   }\n\n   &::-webkit-scrollbar-thumb {\n      border-radius: 5px;\n      background-color: hsl(0, 0%, 90%);\n      box-shadow: inset 0 0 1px 1px #616161;\n   }\n\n   &::-webkit-scrollbar-thumb:hover {\n      background-color: hsl(0, 0%, 85%);\n   }\n\n   &::-webkit-scrollbar-thumb:hover {\n      background-color: hsl(0, 0%, 80%);\n   }\n\n   @media screen and (max-width: 600px) {\n      padding: 0;\n      bottom: 47px;\n   }\n\n   @media screen and (min-width: 600px) {\n      padding: 47px;\n      left: 80px;\n      overflow: scroll;\n   }\n\n   .add-flight-plan {\n      background-color: white;\n      padding: 30px;\n      box-shadow: var(--shadow);\n      border-radius: 5px;\n      margin: auto;\n      width: fit-content;\n      height: fit-content;\n\n      @media screen and (max-width: 600px) {\n         width: 100%;\n         padding: 20px;\n         overflow-y: scroll;\n         max-height: 100%;\n         border-radius: 0;\n      }\n\n      .inputs {\n         position: relative;\n\n         .heading {\n            display: flex;\n            flex-direction: row;\n            justify-content: space-between;\n            align-items: flex-start;\n            margin-bottom: 20px;\n\n            h3 {\n               margin: 0;\n            }\n         }\n\n         .errors {\n            color: red;\n            text-align: center;\n         }\n\n         .date-input-row,\n         .place-input-row {\n            margin-bottom: 5px;\n\n            >* {\n               margin: 5px;\n            }\n         }\n\n         .date-input-row {\n            @media screen and (max-width: 350px) {\n               display: flex;\n               flex-direction: row;\n               align-items: center;\n               justify-content: center;\n               flex-wrap: wrap;\n            }\n         }\n\n         .place-input-row {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            justify-content: center;\n            flex-wrap: wrap;\n\n            .place-input-container {\n               max-width: calc(50% - 30px);\n\n               .place-input {\n                  background-color: white;\n                  width: 220px;\n               }\n            }\n         }\n\n         .text-details {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: center;\n            padding: 0 7px;\n\n            input,\n            textarea {\n               margin: 3px 0;\n               border: 1px solid #d2d2d2;\n               border-radius: 4px;\n               padding: 5px 10px;\n               width: 100%;\n            }\n         }\n\n         .text-details input,\n         .text-details textarea,\n         .place-input-row .place-input-container .place-input {\n            outline: none;\n            box-shadow: 0 0 0 0 var(--accent-color-02-opacity);\n\n            &:focus {\n               border-color: var(--accent-color-light);\n               box-shadow: 0 0 0 3px var(--accent-color-02-opacity);\n            }\n         }\n\n         .privacy-level {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            margin: 10px 0;\n\n            >* {\n               margin-right: 10px;\n            }\n         }\n      }\n\n      .button-container {\n         display: flex;\n         flex-direction: row;\n         justify-content: flex-end;\n         margin-top: 20px;\n      }\n   }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AddTravelPlan_container__6wOJj`,
	"add-flight-plan": `AddTravelPlan_add-flight-plan__qW3bU`,
	"inputs": `AddTravelPlan_inputs__6s4l-`,
	"heading": `AddTravelPlan_heading__GokYp`,
	"errors": `AddTravelPlan_errors__8P1-2`,
	"date-input-row": `AddTravelPlan_date-input-row__jXDyr`,
	"place-input-row": `AddTravelPlan_place-input-row__imSpQ`,
	"place-input-container": `AddTravelPlan_place-input-container__iW-+F`,
	"place-input": `AddTravelPlan_place-input__U9+6w`,
	"text-details": `AddTravelPlan_text-details__8lSqP`,
	"privacy-level": `AddTravelPlan_privacy-level__pkop+`,
	"button-container": `AddTravelPlan_button-container__dABF7`
};
export default ___CSS_LOADER_EXPORT___;
